(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/update-header.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/update-header.js');

'use strict';

const updateHeader = header => {
  const config = {
    title: {
      row1: {
        text: header
      }
    },
    constrain: true
  };
  svs.core.template.updateConfig(config);
};
svs.playerLoginReact.sharedComponents.UpdateHeader = {
  updateHeader
};

 })(window);